import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=1d90499d&scoped=true&"
import script from "./ColorButton.vue?vue&type=script&lang=js&"
export * from "./ColorButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorButton.vue?vue&type=style&index=0&id=1d90499d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90499d",
  null
  
)

export default component.exports